import React, { useEffect, useState, useRef, MouseEvent } from "react";
import { observer } from "mobx-react";

import "../scss/city-picker.scss";
import { ButtonBase, IconButton, Popover } from "@mui/material";
import { styled } from "@mui/system";
import Color from "@/tool/color";
import moWelfare, {
  changeWelfareCity,
  changeWelfareProvince,
} from "../store/wealfare";

interface ICity {
  id: number;
  name: string;
  code: string;
  active: boolean;
}

interface IProps {}
interface IState {}

const DButton = styled(IconButton)(() => ({
  height: "38px",
  width: "38px",
}));

const TitleButton = styled(ButtonBase)(() => ({
  padding: "10px 0",
  width: "100%",
  color: Color.blackColor(0.85),

  "&.active": {
    color: Color.primary,
    backgroundColor: Color.primaryColor(0.04),
  },
  "&:hover": {
    backgroundColor: Color.primaryColor(0.04),
  },
}));

const CButton = styled(ButtonBase)(() => ({
  padding: "13px 0",
  width: "100%",
  color: Color.blackColor(0.65),

  "&.active": { color: Color.primary },
  "&:hover": {
    backgroundColor: Color.primaryColor(0.04),
  },
}));

const CityPicker = (props: IProps, state: IState) => {
  const [isPop, setPop] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const pickerRef = useRef(null);
  const { provinceList, provinceName, cityList, cityNames } = moWelfare;

  useEffect(() => {
    return () => {
      setAnchorEl(null);
    };
  }, []);

  // 打开日期选择框
  const openPop = (ev: MouseEvent) => {
    setAnchorEl(pickerRef.current);
    setPop(true);
  };

  // 关闭日期选择框
  const closePop = (ev: MouseEvent) => {
    ev.stopPropagation();
    setPop(false);
  };

  return (
    <section
      ref={pickerRef}
      className="welfare-city-picker_0059"
      style={{ borderColor: isPop ? Color.primary : Color.blackColor(0.1) }}
      onClick={(ev: MouseEvent) => openPop(ev)}
      aria-hidden="true"
    >
      <section className="picker_00591">
        <i style={{ color: isPop ? Color.primary : Color.blackColor(0.65) }}>
          选择城市
        </i>
        <p>
          <span>{cityNames}</span>
          {/* <CloseIcon color={Color.blackColor(0.5)} /> */}
        </p>
      </section>
      <DButton>{/* <DaysIcon color={Color.blackColor(0.5)} /> */}</DButton>

      <Popover
        open={isPop}
        anchorEl={anchorEl}
        onClose={closePop}
        classes={{ paper: "picker-010" }}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <section className="city-picker_051051">
          <section
            className="sider-051"
            style={{ height: "260px", overflowY: "scroll" }}
          >
            {provinceList?.map((item: any, i: any) => {
              return (
                <TitleButton
                  onClick={(ev: MouseEvent) => {
                    changeWelfareProvince(item.province);
                  }}
                  className={item.province === provinceName ? "active" : ""}
                  key={i}
                >
                  {item.province}
                </TitleButton>
              );
            })}
          </section>

          <section className="city-051">
            {cityList?.map((item: any) => (
              <CButton
                key={item}
                className={item === cityNames ? "active" : ""}
                onClick={(ev: MouseEvent) => {
                  changeWelfareCity(item);
                  closePop(ev);
                }}
              >
                {item}
              </CButton>
            ))}
          </section>
        </section>
      </Popover>
    </section>
  );
};

export default observer(CityPicker);
